(function () {
    'use strict';

    angular.module('app', [
        // Angular modules
        'ui.router',
        'app.errorHandler',
        'ngStorage',
        'angular-loading-bar',
        'ui.bootstrap',
        'ngAnimate',
        'ui.grid',
        'ui.grid.pagination',
        'ui.grid.resizeColumns',
        'ui.grid.moveColumns',
        'ui.grid.selection',
        'ui.grid.edit',
        'perfect_scrollbar',
        'ui.sortable',
        'base64',
        'ngMaterial',
        'vs-repeat',
        'ngCookies',
        'ct.ui.router.extras',
        'ngSanitize',
        'angularFileUpload',
        'ngClipboard',
        'tmh.dynamicLocale',
        'toggle-switch',
        'ui.grid.exporter'
        // Custom modules

        // 3rd Party Modules

    ]);

})();

//window.onbeforeunload = function (e) {
//    return "";
//};